/* 🤖 this file was generated by svg-to-ts */
export const emperorIconBoxReply: {
  name: 'box_reply';
  data: string;
} = {
  name: 'box_reply',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M15.832.445c-.19-.278-.5-.445-.84-.445h-4v6h8.535L15.817.44Z"/><path d="M15 10c1.96 0 3.72.8 5 2.106V8H0v11c0 .55.447 1 1 1h7.683c-.44-.91-.69-1.93-.69-3 0-3.87 3.13-7 7-7Z"/><path d="M9 0H5c-.34 0-.65.167-.84.445L.45 6h8.535V0Z"/><path d="M18 16h-4.586l2.29-2.3 -1.42-1.42 -4.71 4.7 4.7 4.7 1.41-1.42 -2.3-2.3h4.586c2.2 0 4 1.79 4 4v2h2v-2c0-3.31-2.7-6-6-6Z"/></g></svg>`,
};
